import PropTypes from 'prop-types';
import { values } from 'ramda';

import { THEMATIC } from './thematic';
import { MEDIA_THEMATIC } from './media-thematic';
import { EXPERTISE } from './expertise';

export const COMMON_THEMATIC = {
  ...THEMATIC,
  ...MEDIA_THEMATIC,
  ...EXPERTISE,
};

export const CommonThematicType = PropTypes.oneOf(values(COMMON_THEMATIC));
